import { useEffect } from "react";
import YoutubeVideo from "../../components/videoRendering/youtubeVideoRendering";

const CastingProcess = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="relative overflow-hidden pt-6 pb-20">
      {/* 🌈 BACKGROUND DECOR */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full bg-primary/20 blur-3xl" />
        <div className="absolute bottom-0 right-10 h-[300px] w-[300px] rounded-full bg-secondary/20 blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex flex-col items-center gap-20">

        {/* 🧠 HEADER */}
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl sm:text-4xl xl:text-5xl font-d_bold tracking-tight text-primary">
            Revolutionary 3D Medical Casting
          </h1>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            A smarter, cleaner and pain-free alternative to traditional plaster casting.
          </p>
        </div>

          {/* 📝 CONTENT CARD */}
        <div className="w-full flex justify-center">
          <div className="w-full md:w-2/3 xl:w-1/2 bg-white bg-background/70 border border-primary/20 rounded-xl p-4 ">
            <ul className="flex flex-col gap-6 text-center text-sm sm:text-base leading-7 tracking-wide">
              <li className="text-primary font-d_bold">
                Experience the future of medical care at Sacrum —
                where innovation shapes healing.
              </li>
               <li>
                Using advanced <span className="font-d_bold text-primary">3D</span>{" "}
                scanning and imaging, we design a custom-fit cast that maximizes comfort,
                breathability, and healing efficiency.
              </li>
              <li>
                No more hassle, no plaster stains on clothes, no pain during application.
                Our <span className="font-d_bold text-primary">3D</span> medical casting
                process redefines traditional plastering.
              </li>
            </ul>
          </div>
        </div>

       
        <div className="w-full md:w-2/3 relative group">
          <div className="absolute -inset-1 rounded-2xl bg-gradient-to-r from-primary to-secondary opacity-30 blur group-hover:opacity-50 transition" />
          <div className="relative rounded-2xl overflow-hidden border border-primary/20 bg-background shadow-xl">
            <YoutubeVideo videoId="GVzeEKRIj1E" />
          </div>
        </div> 

      

      </div>
    </section>
  );
};

export default CastingProcess;
